var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbarShoppingBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5703 5.64621H14.9274V5.21763C14.9274 2.49621 12.7203 0.289062 9.99885 0.289062C7.27742 0.289062 5.07028 2.49621 5.07028 5.21763V5.64621H1.42742C0.953318 5.64621 0.570282 6.02924 0.570282 6.50335V20.8605C0.570282 21.3346 0.953318 21.7176 1.42742 21.7176H18.5703C19.0444 21.7176 19.4274 21.3346 19.4274 20.8605V6.50335C19.4274 6.02924 19.0444 5.64621 18.5703 5.64621ZM6.99885 5.21763C6.99885 3.5596 8.34082 2.21763 9.99885 2.21763C11.6569 2.21763 12.9989 3.5596 12.9989 5.21763V5.64621H6.99885V5.21763ZM17.4989 19.7891H2.49885V7.57478H5.07028V9.93192C5.07028 10.0498 5.16671 10.1462 5.28457 10.1462H6.78457C6.90242 10.1462 6.99885 10.0498 6.99885 9.93192V7.57478H12.9989V9.93192C12.9989 10.0498 13.0953 10.1462 13.2131 10.1462H14.7131C14.831 10.1462 14.9274 10.0498 14.9274 9.93192V7.57478H17.4989V19.7891Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarShoppingBag);
export default __webpack_public_path__ + "static/media/navbar-shopping-bag.4483e4277a6b845ccbdbf69c5632cd41.svg";
export { ForwardRef as ReactComponent };